import { axis } from './Axis.sty.js';
import { AxisPrimitive } from './AxisPrimitive.js';
import {
  axisFontBaseProps,
  axisFontProps,
  DEFAULT_AXIS_FONT_COLOR,
} from './constants.js';
import { AxisProps } from './types.js';
import { TextProps, TickLabelProps } from '../../types/text-props.js';
import { TickPrimitiveValue } from '../../types/tick-value.js';
import {
  charsFontWidth14pixelsSize400Map,
  charsFontWidth12pixelsSize400Map,
} from '../text-ellipsis/chars-font-width-map.js';
import { truncateString } from '../text-ellipsis/truncate-string.js';

const labelProps: TextProps = { ...axisFontProps, textAnchor: 'middle' };
const labelBaseProps: TextProps = {
  ...axisFontBaseProps,
  textAnchor: 'middle',
};

/**
 * @internal
 */
export const Axis = ({
  width = '100%',
  height = '100%',
  containerSize,
  label,
  size = 'small',
  tickLabelProps = (...args) => ({}),
  tickColor,
  ...restProps
}: AxisProps) => {
  const fontProps = {
    ...(size === 'small' ? axisFontProps : axisFontBaseProps),
    fill: tickColor ?? DEFAULT_AXIS_FONT_COLOR,
  };

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const defaultTickLabelProps: TickLabelProps<TickPrimitiveValue> = (
    ...args: [TickPrimitiveValue, number, any]
  ) => ({
    ...fontProps,
    ...(typeof tickLabelProps === 'function'
      ? tickLabelProps(...args)
      : tickLabelProps),
  });

  const truncatedLabel = label
    ? truncateString(
        label,
        containerSize,
        size === 'small'
          ? charsFontWidth12pixelsSize400Map
          : charsFontWidth14pixelsSize400Map,
        'middle',
      )
    : '';

  return (
    <svg
      className={axis}
      width={width}
      height={height}
      role={restProps.role}
      aria-label={restProps['aria-label'] ?? undefined}
    >
      <AxisPrimitive
        label={truncatedLabel}
        labelProps={size === 'small' ? labelProps : labelBaseProps}
        tickLabelProps={defaultTickLabelProps}
        {...restProps}
      />
    </svg>
  );
};
Axis['displayName'] = 'Axis';
